import React, { FC } from 'react';

import withSchema from 'ia-react-core/~/hocs/schema/withSchema';
import { WorkflowState } from 'ia-react-core/~/interfaces/WorkflowState';

import injectTranslations from 'ia-react-core/~/hocs/translation/injectTranslations';
import injectAnalyticsScope from '../../../hocs/analytics/injectAnalyticsScope';
import withUniqueId from '../../../hocs/helpers/_withUniqueId';
import injectReducer from '../../../hocs/redux/injectReducer';
import injectSaga from '../../../hocs/redux/injectSaga';
import withScope from '../../../hocs/redux/withScope';
import compose from '../../../utils/components/_compose';
import Router from '../../../services/router/Router';

import workflowActions from './Workflow.actions';

import Workflow, { WorkflowComposedProps, WorkflowProps } from './Workflow';
import workflowReducer from './Workflow.reducer';
import workflowSaga from './Workflow.saga';
import workflowValuesReducer from './Workflow.valuesReducer';

import fr from './translations/fr';
import en from './translations/en';

export * from './Workflow';

const Composedworkflow = compose<FC<WorkflowProps>>(
  withScope,
  (WrappedComponent: FC<WorkflowComposedProps>) => (props: WorkflowComposedProps) => {
    const history = Router.useHistory();
    const basename = Router.useHref('/');
    return (
      <WrappedComponent
        {...props}
        history={history}
        basename={basename}
      />
    );
  },
  withUniqueId('workflowId', { acceptOverride: true }),
  withSchema('workflow'),
  injectTranslations('Core.Workflow', { fr, en }),
  injectAnalyticsScope<WorkflowComposedProps>({
    key: ({ name }) => name,
  }),
  injectReducer<WorkflowComposedProps, WorkflowState>({
    key: ({ name }) => name,
    idName: 'workflowId',
    namespace: 'Core/Workflow',
    identifiers: ({ workflowId, name }) => ({ workflowId, name }),
    reducer: workflowReducer,
    actions: workflowActions,
    initialState: ({ workflowId, name, initialStepName, valuesDst }) => ({
      workflowId,
      name,
      currentStepName: initialStepName,
      valuesDst,
    }),
    useScope: true,
    createScope: false,
    cleanState: true,
  }),
  injectReducer<WorkflowComposedProps>({
    namespace: 'Core/Workflow',
    identifiers: ({ workflowId, name }) => ({ workflowId, name }),
    key: ({ valuesDst }) => valuesDst,
    initialState: {},
    useScope: true,
    createScope: false,
    cleanState: ({ cleanValues }) => Boolean(cleanValues),
    reducer: workflowValuesReducer,
  }),
  injectSaga<WorkflowComposedProps>({
    key: ({ workflowId }) => `Workflow${workflowId}`,
    saga: workflowSaga,
  }),
)(Workflow);

Composedworkflow.displayName = 'Workflow';

export default Composedworkflow;
